// @flow
import * as React from 'react';

import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

import { useRouter } from 'next/router';

import {
  StyledWrapper,
  StyledLabelsContainer,
  StyledLabel,
  StyledIcon,
  StyledIconsContainer,
  StyledExpandedList
} from './styles';

const Dropdown = ({
  label,
  children,
  routes,
  heroSection
}: {
  label: string,
  children: React.Node,
  routes: Array<string>,
  heroSection?: boolean
}): React.Node => {
  const {
    query: { nextRoute: currentRoute }
  }: { query: { nextRoute: string } } = useRouter();

  return (
    <StyledWrapper data-dropdown-label={label} className="dropdown-group">
      <StyledLabelsContainer
        data-dropdown-label={label}
        className="dropdown-button"
        isActive={routes.includes(currentRoute)}
        heroSection={heroSection}
      >
        <StyledLabel>{label}</StyledLabel>
        <StyledIconsContainer>
          <StyledIcon icon={faCaretDown} size="xs" />
        </StyledIconsContainer>
      </StyledLabelsContainer>


      <StyledExpandedList data-dropdown-label={label} className="dropdown">
        {children}
      </StyledExpandedList>

    </StyledWrapper>
  );
};

export default Dropdown;
